import { render, staticRenderFns } from "./areaChoose.vue?vue&type=template&id=65c846c2&scoped=true&"
import script from "./areaChoose.vue?vue&type=script&lang=js&"
export * from "./areaChoose.vue?vue&type=script&lang=js&"
import style0 from "./areaChoose.vue?vue&type=style&index=0&id=65c846c2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c846c2",
  null
  
)

export default component.exports